import * as zod from 'zod';

import { Step } from '@sb/remote-control/types';
import { PayloadState } from '@sb/routine-runner/types/PayloadState';

import { ActuateGripperStepDatabase } from './ActuateGripperStepDatabase';

export namespace EnableGripperStepDatabase {
  export const name = 'Enable gripper';
  export const description = 'Enable a gripper for use';
  export const { deviceKinds } = ActuateGripperStepDatabase;
  export const librarySection = Step.LibrarySection.Basic;
  export const librarySort = '2';
  export const argumentKind = 'EnableGripper';

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    deviceID: zod.string().optional(),
    payload: PayloadState.nullable().default(null),
    waitForGripperToInitialize: zod.boolean().default(false),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    return {
      ...stepData,
      stepKind: 'EnableGripper',
      args: {
        deviceID: args.deviceID,
        payload: args.payload,
        waitForGripperToInitialize: args.waitForGripperToInitialize,
      },
    };
  };
}

EnableGripperStepDatabase satisfies Step.StepKindInfo;
